import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";

const AccordianOffer = ({ hideDesc = false }) => {
    return (
        <Swiper
            className="column_swiper_1"
            // spaceBetween={6}
            spaceBetween={12}
            // slidesPerView={data?.response?.dynamictypes?.cards?.length<=2?"auto":1.1}
            // slidesPerView={1.1}
            // slidesPerView="auto"
            slidesPerView={1.1}
            // grid={{ cols: 3, fill: "col" }}
            // modules={[Grid, Pagination]}
            breakpoints={{
                768: {
                    slidesPerView: 1.8,
                },
                0: {
                    slidesPerView: 1.8
                }
            }}
        >
            {
                [1, 2, 3]?.map(item => {
                    return (
                        <SwiperSlide>
                            <div
                                className="card_style_1 height_100 "
                            >
                                <div className="card_img shimmerBG shimmer-img-md">
                                    {/* <img
            src={
              process.env.PUBLIC_URL + '/assets/images/dummy_img.jpg'
            }
            alt=""
            title=""
          /> */}
                                </div>
                                <div className="card_info text-center">
                                    <div className="card_info_grp">
                                        <h4 className="text-ellipsis shimmerBG shimmer-text-sm w-60 mx-auto"></h4>
                                        {
                                            !hideDesc && (
                                                <>
                                                    <p className='shimmerBG shimmer-p-text height-10' style={{ minHeight: '0px' }}></p>
                                                    <p className='shimmerBG shimmer-p-text height-10' style={{ minHeight: '0px' }}></p>
                                                </>
                                            )
                                        }

                                    </div>
                                    <div className="card_link">
                                        <div
                                            className="hyperlink shimmerBG shimmer-text-sm w-40"
                                        >
                                            {/* button
              <img
                src={
                  process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'
                }
                alt=""
                title=""
              /> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    )
                })
            }
        </Swiper>
    )
}

export default AccordianOffer